import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  // Fonction pour vérifier la validité de la session
  const checkSessionValidity = async () => {
    const adminToken = localStorage.getItem('adminToken');
    if (!adminToken) {
      setIsAuthenticated(false);
      setUser(null);
      return false;
    }

    try {
      // Vérifier la validité du token en testant une route protégée légère
      await api.get('/api/v1/stations', { 
        params: { limit: 1 },
        timeout: 5000 
      });
      setIsAuthenticated(true);
      setUser({ type: 'admin', token: adminToken });
      return true;
    } catch (error) {
      // Token invalide, le supprimer
      localStorage.removeItem('adminToken');
      setIsAuthenticated(false);
      setUser(null);
      return false;
    }
  };

  useEffect(() => {
    // Vérifier si un token admin existe au démarrage
    checkSessionValidity().finally(() => {
      setLoading(false);
    });

    // Vérifier périodiquement la validité de la session (toutes les 5 minutes)
    const intervalId = setInterval(() => {
      checkSessionValidity();
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const login = (token) => {
    localStorage.setItem('adminToken', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setIsAuthenticated(true);
    setUser({ type: 'admin', token });
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    delete api.defaults.headers.common['Authorization'];
    setIsAuthenticated(false);
    setUser(null);
  };

  const value = {
    isAuthenticated,
    loading,
    user,
    login,
    logout,
    checkSessionValidity
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

